const common = {
  'app.name': 'ZeitGeist',
  'app.tagline': 'Zeiterfassungssystem',
  'lang.label': 'Sprache',
  'lang.de': 'Deutsch',
  'lang.en': 'Englisch',

  'nav.dashboard': 'Dashboard',
  'nav.times': 'Zeiterfassung',
  'nav.month': 'Monatsübersicht',
  'nav.year': 'Jahresübersicht',
  'nav.alltime': 'Gesamtübersicht',
  'nav.vacation': 'Urlaub',
  'nav.absences': 'Abwesenheiten',
  'nav.calendar': 'Kalender',
  'nav.employees': 'Mitarbeiter',
  'nav.teams': 'Teams',
  'nav.admin': 'Admin',
  'nav.adminUsers': 'Benutzerverwaltung',
  'nav.adminRoles': 'Rollen & Berechtigungen',
  'nav.adminSchedules': 'Arbeitszeitmodelle',
  'nav.adminTeam': 'Team-Übersicht',
  'nav.adminTeams': 'Teams verwalten',
  'nav.adminOverview': 'Übersicht',
  'nav.logout': 'Abmelden',

  'login.personnelNumber': 'Personalnummer',
  'login.personnelNumberPlaceholder': 'z.B. 0001',
  'login.password': 'Passwort',
  'login.submit': 'Anmelden',
  'login.failed': 'Anmeldung fehlgeschlagen',
  'login.greeting': 'Hallo, {name}!',
  'login.whatToDo': 'Was möchtest du tun?',
  'login.checkInOffice': 'Büro – Einstempeln',
  'login.checkInHome': 'Homeoffice – Einstempeln',
  'login.checkOut': 'Ausstempeln',
  'login.toOverview': 'Zur Übersicht',
  'login.checkInError': 'Fehler beim Einstempeln',
  'login.checkOutError': 'Fehler beim Ausstempeln',
};

export default common;
